import React, { useState, useEffect } from 'react';
import root from 'react-shadow';
import styled from 'styled-components';
import FloatingButton from './components/FloatingButton';
import MessagePopup from './components/MessagePopup';
import { WidgetContextProvider, WidgetContextConsumer } from './WidgetContext';
import qs from 'querystring';
import widgetService from './widget-service';
import fbpixel from './fbpixel';

const Root = styled(({ state, ...rest }) => (
  <div className='tecobi-widget' {...rest}>
    <FloatingButton />
    <MessagePopup />
    <style id='tecobi-extra-css'>
      {state.config?.smswidgetconfig?.extra_css}
    </style>
  </div>
))`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  // margin-left: 10px;
  position: absolute;
  bottom: 10px;
  right: ${(props) =>
    props.state.config?.smswidgetconfig?.pin_left ? 'unset' : '120px'};
  left: ${(props) =>
    props.state.config?.smswidgetconfig?.pin_left ? '10px' : 'unset'};
`;

const Widget: React.FC<any> = (props) => {
  const [config, setConfig] = useState();
  const [clientId, setClientId] = useState<number>();

  useEffect(() => {
    async function load() {
      try {
        const script = document.getElementById('tecobi-widget-script');
        const params = qs.parse(window.location.search.substring(1));

        const legacyNode = document.getElementById(
          'tecobi-widget-include'
        ) as any;

        const clientId =
          params.tecobiClientId ??
          script?.dataset?.clientid ??
          legacyNode?.src?.split?.('clientId=')?.[1];

        if (!clientId) {
          return;
        }

        const { data } = await widgetService.getWidgetConfig(clientId);
        setClientId(parseInt(clientId.toString()));
        setConfig(data);
        fbpixel(data);
      } catch (e) {
        console.error(e);
      }
    }

    load();
  }, []);

  return config ? (
    <WidgetContextProvider initial={{ config, clientId }}>
      <root.div {...props}>
        <WidgetContextConsumer>
          {({ state }) => <Root state={state} />}
        </WidgetContextConsumer>
      </root.div>
    </WidgetContextProvider>
  ) : null;
};

export default Widget;
